import React from 'react';
import AuditLogs from '../components/superadmin/AuditLogs';

const SuperadminAuditLogsPage = () => {
  return <AuditLogs />;
};

export default SuperadminAuditLogsPage;

